import {FC} from "react"
import {Block} from "./Block"
import {CoursePageProps} from "./CoursePageProps"
import {HeadlineText} from "./HeadlineText"

export const EyeOfTheStormDescription: FC<Pick<CoursePageProps, "course">> = () => {
  return (
    <>
      <Block>
        <HeadlineText>Курс «В центре урагана»</HeadlineText>
        <p>
          Это программа для всех, кого сейчас штормит и бросает из стороны в сторону.
          Для всех, у кого земля ушла из-под ног. Для всех, кто растерян, расстроен и не знает,
          как жить дальше. Для тех, кто уехал. И для тех, кто остается. Для всех, кто
          испытывает тревогу, страх, разочарование, горечь, апатию, гнев, раздражение,
          беспомощность. Для всех, кто оказался в эпицентре жизненной бури.
        </p>
        <p><strong>Курс поможет:</strong></p>
        <ul className="list-rhombus">
          <li>Обрести опору и устойчивость</li>
          <li>Лучше справляться с сильными эмоциями</li>
          <li>Научиться расслабляться и переключаться, даже если кажется, что это невозможно</li>
          <li>Снизить тревогу и улучшить сон</li>
          <li>Найти ресурс, чтобы поддержать себя и двигаться дальше</li>
        </ul>
      </Block>

      <Block>
        <p>
          Программа рассчитана на 30 дней, но вы можете проходить ее в комфортном для вас режиме,
          ограничений по доступу нет и не будет.
        </p>
        <p>
          Каждый день курса будет содержать: главную практику - это аудио медитация, направленная
          на конкретную психологическую мишень, а также дополнительные тексты и упражнения.
          Помимо этого, у вас будет возможность анонимно общаться в чате Telegram
          <strong> с профессиональным психологом-консультантом</strong>.
          Ему можно будет задавать любые волнующие вас вопросы, он будет отвечать
          в течение нескольких часов.
        </p>
      </Block>
      <Block>
        <p>Перед началом мы предложим вам короткий опросник, это нужно,
          чтобы подобрать вам наиболее подходящие практики.
        </p>
        <p>
          И еще маленький комментарий: часть текстов в онбординге и дашборде будет на английском.
          Это произошло, потому что наши продукт и программы англоязычные, но мы очень хотели
          побыстрее запустить этот курс и дать доступ к нему тем людям, которым сейчас это
          необходимо. Не переживайте, сама программа будет на русском. Надеемся на ваше понимание :)
        </p>

      </Block>
    </>
  )
}
